<template>
  <dashboard-page title="Novo requerimento">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <issues-form-validation></issues-form-validation>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </dashboard-page>
</template>

<script>
import IssuesFormValidation from "./IssuesForm/IssuesFormValidation.vue";
export default {
  name: "issues-form",
  components: {
    IssuesFormValidation
  },
  data() {
    return {};
  }
};
</script>
